import { jsx as _jsx } from "react/jsx-runtime";
export function Divider() {
    return (_jsx("hr", { className: "border-gray-100 w-full" }));
}
